import axios from "axios";

export interface IDocumentationForm {
  title?: string;
  description?: string;
  category: string;
  patient?: string;
  employee?: string;
}

export const getClinicPatients = async ({
  clinicCode,
  perPage,
  currentPage,
  searchValue,
}: {
  clinicCode: string;
  perPage: number;
  currentPage: number;
  searchValue: string;
}) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_URL}/clinic/patients?perPage=${perPage}&page=${currentPage}&search=${searchValue}&clinicCode=${clinicCode}`,
      {
        withCredentials: true,
      }
    )
    .then((response) => response.data);
};

export const getPatientDetails = async (id?: string) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/user/patients/${id}`, {
      withCredentials: true,
    })
    .then((response) => response.data.user);
};
